import type {Cita} from '../services/citasService';
/** The service type is authoritative; an affiliation may not yet be activated. */
export const isVirtualOffice = (cita: Pick<Cita, 'servicio_info'>): boolean =>
    cita.servicio_info?.tipo_servicio === 'oficina_virtual';
